import React from 'react';
import { CircularProgress, Grid } from '@quillbot/design-system';
import { LAYOUT_VALS } from 'src/researcher/constants/common.constants';
import { TextDialogWithCircularProgress } from './Dialog';

export const CoWriterLoader = (props: React.ComponentProps<any>) => (
  <Grid
    container
    justifyContent="center"
    alignItems="center"
    style={{
      height: LAYOUT_VALS.contentHeight,
    }}
    {...props}
  >
    <Grid item>
      <CircularProgress />
    </Grid>
  </Grid>
);
